import { render, staticRenderFns } from "./MPopupLogin.vue?vue&type=template&id=bc171214&"
import script from "./MPopupLogin.vue?vue&type=script&lang=ts&"
export * from "./MPopupLogin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports